"use client";

export const FormLayoutColorVariants = {
  hidden: {
    backgroundColor: "rgba(255, 255, 255, 0.0)",
    backdropFilter: "blur(0px)",
    "-webkit-backdrop-filter": "blur(0px)",
  },
  visible: {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    backdropFilter: "blur(10.5px)",
    "-webkit-backdrop-filter": "blur(10.5px)",
    transition: {
      ease: "circOut",
      duration: 0.25,
      delay: 0.1,
      delayChildren: 0.25,
      staggerChildren: 0.1,
    },
  },
};

// @keyframes gradient {
// 	0% {
// 		background-position: 0% 50%;
// 	}
// 	50% {
// 		background-position: 100% 50%;
// 	}
// 	100% {
// 		background-position: 0% 50%;
// 	}
// }

import { cn } from "@frontend/shared/lib/utils";
import type React from "react";

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | React.ReactNode;
  $width?: string;
  width?: string;
  $labelColor?: string;
  $secondary?: string; // Optional
  error?: boolean | string;
  background?: string;
  inputRef?: React.Ref<HTMLInputElement>; // Optional
  autoFocus?: boolean; // Optional
  readonly?: boolean; // Optional
  InputProps?: {
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  };
  "data-cy": string;
  questionId?: number;
  inputClassNames?: string;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  $width = "100%",
  width = $width,
  $labelColor = "#6b7280",
  $secondary,
  error,
  style,
  type = "text",
  "data-cy": dataCy,
  name,
  onChange,
  inputRef,
  autoFocus,
  disabled,
  readonly,
  placeholder,
  background,
  InputProps = {},
  questionId = 0,
  inputClassNames,
  ...props
}) => {
  const inputId =
    props.id || `form-input-${Math.random().toString(36).substr(2, 9)}`;

  const mergedInputProps = {
    ...InputProps.inputProps,
    readOnly: readonly,
  };

  return (
    <div
      className="relative"
      style={{
        width,
        ...style,
      }}
    >
      {label && (
        <label
          data-questionid={questionId}
          data-pdflabel="text-label"
          htmlFor={inputId}
          className={`
            absolute left-0 
            text-sm font-normal
            w-full break-words leading-tight
            transition-all duration-200
            transform -translate-y-[calc(100%+0.5rem)]
          `}
          style={{
            color: $labelColor,
          }}
        >
          {label}
        </label>
      )}
      <input
        data-pdflabel="text-input"
        id={inputId}
        type={type}
        onChange={onChange}
        data-cy={dataCy}
        ref={inputRef}
        name={name}
        autoFocus={autoFocus}
        disabled={disabled}
        placeholder={placeholder}
        {...mergedInputProps}
        {...props}
        style={{
          height: "100%",
          backgroundColor: disabled ? "lightgray" : background,
        }}
        className={cn(
          "w-full border rounded bg-white/10 p-2.5 text-sm font-normal transition-all duration-200 focus:outline-none placeholder:text-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed",
          inputClassNames,
          error ? "border-red-500 focus:border-red-500" : "",
          readonly && "cursor-default",
        )}
      />
    </div>
  );
};
